import { faGithub, faLinkedin } from "@fortawesome/free-brands-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React, { useContext, useRef, useState } from "react";
import { Button, Modal } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import Spacer from "../../components/Utils/Spacer";
import { Context } from "../../context";

const Contact = () => {
  const { debug, linkedin, github, lang } = useContext(Context);
  const [message, setMessage] = useState("");
  const [showMessage, setShowMessage] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState(null);
  const recaptcha = useRef();
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
    if (recaptcha.current) {
      const captchaValue = recaptcha.current.getValue();
      if (captchaValue) {
        // console.log("Captcha Value:", captchaValue);
      }
    }
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({
      ...formData,
      [name]: value,
      subject: "Email da davidebalice.dev",
    });
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!recaptchaToken) {
      console.error("reCAPTCHA verification failed.");
      return;
    }

    const captchaValue = recaptcha.current.getValue();
    if (!captchaValue) {
      alert("Please verify the reCAPTCHA!");
    } else {
      const res = await fetch(`${process.env.REACT_APP_EMAIL_API}/verify`, {
        method: "POST",
        body: JSON.stringify({ captchaValue }),
        headers: {
          "content-type": "application/json",
        },
      });
      const data = await res.json();
      if (data.success) {

        try {
          const response = await fetch(
            `${process.env.REACT_APP_EMAIL_API}/send`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify(formData),
            }
          );
          const data = await response.json();
          console.log(data);

          setFormData({
            name: "",
            email: "",
            message: "",
            subject: "Email da davidebalice.dev",
          });

          setShowMessage(true);
          setMessage(data.message);
        } catch (error) {
          console.error(error);
        }
      } else {
        alert("reCAPTCHA validation failed!");
      }
    }
  };

  const handleCloseMessage = () => {
    setShowMessage(false);
  };

  return (
    <section id="contact" className="section">
      <Modal show={showMessage} onHide={handleCloseMessage}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>{message}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseMessage}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="container">
        {lang === "it" && (
          <p className="contanctMessage">
            Contattami, risponderò nel più breve tempo possibile
          </p>
        )}
        {lang === "en" && (
          <p className="contanctMessage">
            Contact me, I will reply as soon as possible
          </p>
        )}

        <div className="row gy-5">
          <div className="col-md-4 col-xl-3 order-1 order-md-0 text-center text-md-start">
            <p className="text-3 mb-4">
              <span className="text-primary text-4 me-2">
                <i className="fas fa-envelope"></i>
              </span>
              davide.balice@gmail.com
            </p>

            <ul className="social-icons2 justify-content-center justify-content-md-start">
              <li className="social-icons-linkedin2">
                <a href={linkedin} target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faLinkedin} size="2x" />
                </a>
              </li>
              <li className="social-icons-github2">
                <a href={github} target="_blank" rel="noreferrer">
                  <FontAwesomeIcon icon={faGithub} size="2x" />
                </a>
              </li>
            </ul>
          </div>
          <div className="col-md-8 col-xl-9 order-0 order-md-1">
            <form onSubmit={handleSubmit} id="contact-form">
              <div className="row g-4">
                <div className="col-xl-6">
                  <input
                    name="name"
                    type="text"
                    className="form-control contactInput"
                    required
                    placeholder="Name"
                    onChange={handleInputChange}
                    value={formData.name}
                  />
                </div>
                <div className="col-xl-6">
                  <input
                    name="email"
                    type="email"
                    className="form-control contactInput"
                    required
                    placeholder="Email"
                    onChange={handleInputChange}
                    value={formData.email}
                  />
                </div>
                <div style={{ display: "none" }}>
                  <input
                    type="text"
                    name="honeypot"
                    onChange={handleInputChange}
                    value={formData.honeypot || ""}
                  />
                </div>
                <div style={{ display: "none" }}>
                  <input
                    type="text"
                    name="subject"
                    value={"Email da davidebalice.dev"}
                    value={formData.subject}
                  />
                </div>
                <div className="col">
                  <textarea
                    name="message"
                    className="form-control contactInput"
                    rows="5"
                    required
                    placeholder="Tell us more about your needs........"
                    onChange={handleInputChange}
                  >
                    {formData.message}
                  </textarea>
                </div>
              </div>
              <p className="contanctBottom">
                <ReCAPTCHA
                  ref={recaptcha}
                  sitekey={process.env.REACT_APP_SITE_KEY}
                  onChange={handleRecaptchaChange}
                />

                <button
                  id="submit-btn"
                  className="btn btn-primary rounded-pill contactButton"
                  type="submit"
                >
                  Send Message
                </button>
              </p>
            </form>
            <Spacer height={100} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
